<template>
  <div class="container">
    <div class="card-list">
      <template v-for="item in dataList">
        <div
          class="list-item"
          @click="videoPlay(item.mediaUrl, item.vId)"
          :key="item.id"
          v-if="item.headPortrait"
        >
          <div class="item-top">
            <img
              :src="item.headPortrait"
              class="person-via"
              v-if="item.headPortrait"
            />
            <img src="@/assets/1.jpg" class="person-via" v-else />
            <div class="item-rigth">
              <div class="item-rigth-info">
                <span class="item-rigth-info-name">{{ item.name }}</span>
                <span class="item-rigth-info-unit">{{ item.unit }}</span>
              </div>
              <span class="post">{{ item.post }}</span>
              <span class="post-info show-2">{{ item.postInfo }}</span>
            </div>
          </div>
          <div class="play-menu">
            <span class="post">{{ item.course }}</span>
            <span class="iconfont icon-hebingxingzhuang"></span>
          </div>
        </div>
      </template>

      <!-- <div class="list-item">
        <div class="item-top">
          <img src="@/assets/1.jpg" class="person-via">
          <div class="item-rigth">
            <div class="item-rigth-info">
              <span class="item-rigth-info-name">姚琳</span>
              <span class="item-rigth-info-unit">浙江省力同德医院</span>
            </div>
            <span class="post">分会主任委员，中华医学会放射</span>
            <span class="post-info">中华医学会放射学分会主任委员，中华医学会放射学分会主任委员，中华医学会放射学分会主任委员，中华医学会放射…</span>
          </div>
        </div>
        <div class="play-menu">
          <span class="iconfont icon-hebingxingzhuang"></span>
        </div>
      </div> -->
    </div>
    <div class="video-box" v-show="isPlayer" @click="endedPlay">
      <!-- <video id="myVideo" class="video-js">
      <source src="http://vfx.mtime.cn/Video/2019/03/21/mp4/190321153853126488.mp4" type="video/mp4">
    </video> -->

      <div
        :class="['v-video-wrap', isRotate ? 'v-rotate-90' : '']"
        @click.stop=""
      >
        <!--<video id="myVideo" class="video-js vjs-default-skin" controls="" preload="auto" x5-playsinline="" playsinline=""
        webkit-playsinline="" poster="" x-webkit-airplay="allow" style='width: 100%;height: auto'>
        <source src="" type="video/mp4">
      </video>-->
        <video :src="mediaUrl" class="v-video" controls autoplay id="myVideo">
          <source :src="mediaUrl" type="video/mp4" />
        </video>
        <span class="v-all-screen" @click.stop="allScreen">全屏</span>
        <!--<player :url="mediaUrl" v-if="mediaUrl&&isPlayer"></player>-->
        <!--<div id="id_test_video"></div>-->
        <div class="load-text" v-if="isShowVideoLoad">努力加载中....</div>
      </div>
    </div>
  </div>
</template>
<script>
//  import { TcPlayer } from '../../utils/player'
import { jsonData, vData, daKa } from "../../utils/json.js";
//  import player from '../../components/iVideo'
import VideoJs from 'video.js'

let myPlayer = null;
export default {
  //    components:{
  //      player
  //    },
  data() {
    return {
      myPlayer: "",
      isPlayer: false,
      mediaUrl: "",
      dataList: [],
    isRotate: false,
    isShowVideoLoad:false,
    };
  },
  mounted() {
  var _this=this;
    if (JSON.stringify(this.$route.params) !== "{}") {
      //行业分享
      this.dataList = vData[this.$route.params.index];
    } else {
      //大咖视频
      this.dataList = daKa;
  }
  var vdom=document.getElementById('myVideo')
  vdom.addEventListener('canplay',function(){
    _this.isShowVideoLoad=false;
  },false)
  },
  methods: {
    videoPlay(mediaUrl, vId) {
      if (!mediaUrl) {
        this.$dialog.alert({
          message: "暂无视频！",
        });
        return "";
      }
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf("micromessenger") > -1) {
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            //在小程序中
            wx.miniProgram.navigateTo({
              url: "/pages/live/videoPlay/videoPlay?vid=" + vId,
            });
          }
        });
        return "";
    }
    this.isShowVideoLoad=true;
      this.mediaUrl = mediaUrl;
      this.isPlayer = true;
      //----
      //        document.getElementById('id_test_video').innerHTML = '';
      //        var h=Math.floor(innerHeight/3);
      //        this.player = new TcPlayer('id_test_video', {
      //          "mp4": mediaUrl,
      //          "x5_player": true,
      //          "x5_type": 'h5',
      //          "x5_orientation": 0,
      //          "width":innerWidth+'px',
      ////          "width":innerHeight+'px',
      //          "heiht":"20vh"
      //        })
    },
    //  videoPlay (mediaUrl) {
    //    if(!mediaUrl){
    //      this.$dialog.alert({
    //        message:"暂无视频！"
    //      })
    //      return ''
    //    }
    //    myPlayer.pause();
    //    var data = {
    //      src: mediaUrl
    //    };
    //    myPlayer.src(data);
    //    myPlayer.load(data);
    //    this.isPlayer = true;
    //    myPlayer.play();
    //  },
    endedPlay() {
      //        myPlayer.pause();
      //        myPlayer.ended();
      this.isPlayer = false;
      this.mediaUrl = "";
      // myPlayer.enterFullScreen();
    },
    initVideo() {
      //初始化视频方法
      myPlayer = VideoJs(myVideo, {
        bigPlayButton: true, //是否显示播放按钮（这个播放按钮默认会再左上方，需用CSS设置居中）
        textTrackDisplay: true,
        posterImage: true,
        errorDisplay: true,
        controlBar: true,
        autoplay: false, //这个说是自动播放，但是本人使用无效
        controls: true,
      });
    },
    allScreen() {
      this.isRotate = !this.isRotate;
    },
  },
};
</script>
<style lang="scss">
.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  background: #f5f6fa;
}

.person-via {
  max-width: 74px;
  width: 100%;
  height: 74px;
  border-radius: 100%;
  object-fit: cover;
}

.list-item {
  display: flex;
  flex-direction: column;
  /*padding: 15px;*/
  margin: 0 15px 15px 15px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
}

.item-top {
  display: flex;
  flex-direction: row;
  padding: 15px 15px 0;
}

.list-item:first-child {
  margin-top: 15px;
}

.item-rigth {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-top: 2px;
}

.item-rigth-info {
  &-name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(49, 57, 69, 1);
  }
  &-unit {
    margin-left: 12px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(148, 144, 69, 1);
  }
}

.post {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 400;
  color: rgba(49, 57, 69, 1);
}

.color {
  color: #ebf5e7;
}

.post-info {
  margin-top: 8px;
  font-size: 11px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}

.play-menu {
  display: flex;
  margin-top: 15px;
  // justify-content: flex-end;
  justify-content: space-between;
  padding-right: 2px;
  background: #ebf5e7;
  padding: 10px 15px;
}

.icon-hebingxingzhuang {
  font-size: 23px;
  color: rgba(2, 16, 83, 0.1);
  border: 0px solid rgba(245, 245, 245, 1);
}

.video-box {
  top: 0;
  /* position: fixed; */
  display: flex;
  position: fixed;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.vjs-big-play-button {
  z-index: 10;
  left: 50% !important;
  top: 50% !important;
  margin-top: -1em;
  margin-left: -1.5em;
}

.video-js .vjs-tech {
  position: static;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.v-video-wrap {
  position: relative;
  width: 100%;
  .v-all-screen {
    position: absolute;
    /*right: 0;
      bottom: 0;*/
    right: 12vw;
    bottom: 10vw;
    z-index: 99;
    background: red;
    padding: 2vw;
    opacity: 0;
  }
}

.v-rotate-90 {
  transform: rotate(90deg) scale(0.85);
  width: 100vh;
  .v-all-screen {
    right: 7.5vh;
    /*padding:2vw 5vw;*/
    /*bottom: 18vw;*/
    /*transform: scale(0.85);*/
  }
}

.v-video {
  width: 100%;
}

#id_test_video {
  height: 30vh;
}

video::-webkit-media-controls-fullscreen-button {
  /*display: none;*/
  pointer-events: none;
}
.load-text {
  color: red;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}
</style>
